import React, { Component } from 'react';
import {withRouter} from 'react-router';

class Home extends Component {
  componentDidMount() {
    this.props.history.push('/berichten');
    document.querySelector('title').innerHTML = 'MijnDP - Home';
  }
  render() {
    return (
      <div>
           <div className="card__header">
                <h1>Dashboard</h1>
            </div>
            <div className="card__body">
            </div>
      </div>
    );
  }

}

export default withRouter(Home);



// WEBPACK FOOTER //
// ./src/components/Home/index.js